module.exports = __webpack_public_path__ + "img/staff_add.a694b8b8.svg";